import React                            from 'react';
import {render, unmountComponentAtNode} from 'react-dom';
import PjaxWrapper                      from '../../utils/PjaxWrapper';
import VideoSuggestion                  from '../../components/TV/VideoSuggestion';


function run(viewerContainerId, suggestion) {
	const viewerContainer = document.getElementById(viewerContainerId);
	if (viewerContainer && suggestion) {
		render(
			<VideoSuggestion {...suggestion} />,
			viewerContainer
		);

		PjaxWrapper.addUnloadFunc(() => unmountComponentAtNode(viewerContainer));
	}

}


export {run};
